import * as React from 'react';

import {deserializeFieldNames} from 'nutshell-core/entities/deserialize-fields';
import type {FilterObject} from 'nutshell-core/types';

import {getReportDefaultFields} from '../../../reports/report-constants';
import type {ReportURLParams} from '../../../reports/report-types';

import {CompaniesListContainer} from './companies-list-container';

type Props = {
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => any;
    urlParams: ReportURLParams<'mcfxcompanies'>;
    onRemoveAllFilters: () => void;
    onOpenSidebar: (id: string) => void;
};

export function CompaniesList(props: Props) {
    const listParams = props.urlParams.list || {};
    const excludedColumn = 'unlockTime';

    const listSelectedFields =
        // @ts-expect-error
        listParams.fields && listParams.fields.mcfxcompanies
            ? // @ts-expect-error
              deserializeFieldNames(listParams.fields.mcfxcompanies)
            : deserializeFieldNames(getReportDefaultFields('mcfxcompanies')).filter(
                  (e) => e !== excludedColumn
              );

    const search = props.urlParams.q || '';

    return (
        <div className='routed-report-content' id='companies-list'>
            <CompaniesListContainer
                filters={props.activeFilters}
                search={search}
                selectedPage={
                    // @ts-expect-error
                    listParams.page && Number(listParams.page) ? Number(listParams.page) : 1
                }
                onRemoveAllFilters={props.onRemoveAllFilters}
                // @ts-expect-error
                selectedSortField={listParams.sort}
                selectedFields={listSelectedFields}
                onParamChange={props.onParamChange}
                urlParams={props.urlParams}
                onOpenSidebar={(id: string) => props.onOpenSidebar(id)}
            />
        </div>
    );
}
